module.exports = __webpack_public_path__ + "static/img/screenshot.f44ce65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/screenshot.jpg
// module id = MlDK
// module chunks = 3